"use client";

import { useState, useEffect } from "react";
import { Button } from "@/components/ui/button";
import { ArrowUp } from "lucide-react";

const SCROLL_THRESHOLD = 400;

export function BackToTop() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setVisible(window.scrollY > SCROLL_THRESHOLD);
    };
    window.addEventListener("scroll", handleScroll, { passive: true });
    handleScroll();
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  if (!visible) return null;

  return (
    <Button
      variant="secondary"
      size="icon"
      className="fixed z-40 size-11 rounded-full shadow-lg [bottom:max(1.5rem,env(safe-area-inset-bottom))] [right:max(1.5rem,env(safe-area-inset-right))] md:[bottom:max(2rem,env(safe-area-inset-bottom))] md:[right:max(2rem,env(safe-area-inset-right))]"
      onClick={scrollToTop}
      aria-label="Back to top"
    >
      <ArrowUp className="size-5" />
    </Button>
  );
}
